import { createQueryKeys } from '@lukemorales/query-key-factory';

export const exclusiveUnits = createQueryKeys('exclusiveUnits', {
  project: (catalogueProjectId: number) => [catalogueProjectId],
  salesKit: (catalogueProjectId: number) => ['salesKit', catalogueProjectId],
  myHolds: null,
  manager: null,
  holdClients: (search: string) => [search],
});
